<nz-select
  #userSelect
  class="user-search"
  nzPlaceHolder="Search for a user..."
  nzShowSearch
  nzServerSearch
  [nzCustomTemplate]="userTpl"
  [nzOptionHeightPx]="userLookupState === lookupStateEnum.RESULT ? 76 : 32"
  [nzOptionOverflowSize]="2"
  [nzLoading]="userLookupState === lookupStateEnum.LOADING"
  (nzOnSearch)="onSearch($event)"
>
  <ng-container *ngIf="foundUsers$ | async as foundUsers; else noUsers">
    <nz-option
      *ngFor="let user of foundUsers; trackBy: trackByRef"
      [nzValue]="user"
      [nzLabel]="user.displayName!"
      [nzHide]="userLookupState !== lookupStateEnum.RESULT"
      nzCustomContent
    >
      <div nz-row nzType="flex" nzJustify="start" nzAlign="middle">
        <div nz-col [nzSpan]="3">
          <nz-avatar
            nzIcon="user"
            nzAlt="profile picture"
            [nzSrc]="(user?.imageUrl$ | async) ?? '' | emApplyPure: fixPjpegAvatar"
          ></nz-avatar>
        </div>
        <div nz-col>
          <span nz-text>{{ user?.displayName }}</span>
          <span nz-text nzType="secondary">({{ user?.shortName }})</span>
          <div>
            <span nz-text nzType="secondary">{{ user?.jobTitle }}</span>
          </div>
          <div>
            <span nz-text nzType="secondary">{{ user?.email }}</span>
          </div>
        </div>
      </div>
    </nz-option>
  </ng-container>

  <ng-template #noUsers>
    <nz-option *ngIf="userLookupState === lookupStateEnum.RESULT" nzDisabled nzCustomContent>
      No users matched search criteria
    </nz-option>
  </ng-template>

  <nz-option
    nzDisabled
    nzCustomContent
    [nzHide]="userLookupState === lookupStateEnum.RESULT"
    [ngSwitch]="userLookupState"
  >
    <span *ngSwitchCase="lookupStateEnum.INIT">Type at least 2 letters to search</span>
    <span *ngSwitchCase="lookupStateEnum.LOADING">
      <i nz-icon nzType="loading"></i>
      Loading Data...
    </span>
    <!-- eslint-disable-next-line @angular-eslint/template/cyclomatic-complexity-->
    <span *ngSwitchCase="lookupStateEnum.ERROR" nz-text nzDanger>
      <i nz-icon nzType="warning"></i>
      {{ userLookupErrorMsg }}
    </span>
  </nz-option>
</nz-select>

<ng-template #userTpl let-selected>
  <span nz-row nzAlign="middle">
    <nz-avatar
      nz-col
      [nzSpan]="3"
      nzSize="small"
      nzIcon="user"
      nzAlt="profile picture"
      [nzSrc]="selected?.nzValue?.imageUrl$ | async | emToString"
    ></nz-avatar>
    <span nz-col [nzOffset]="2">
      <span nz-text>{{ selected?.nzValue?.displayName }} ({{ selected?.nzValue?.shortName }})</span>
    </span>
  </span>
</ng-template>
